<div class="wrapper">
  <i
  class="fas fa-times clickable"
  (click)="activeModal.dismiss('Cross click')"
></i>
  <header>
    <ng-container i18n="@@auditlog.header">Audit log</ng-container>
    <span class="address"
      >{{ building.street }} {{ building.number }} {{ building.postalCode }}
      {{ building.city }}</span
    >
  </header>
  <div class="content" *ngIf="!loading">
    <div class="items-scroll scrollable">
      <div class="items">
        <div
          class="item card"
          [ngClass]="{ selected: record.selected | async }"
          *ngFor="let record of records; let i = index"
          (click)="record.select()"
        >
          <div class="date">{{ record.date }}</div>
          <div class="title">{{ record.type }}</div>
        </div>
      </div>
    </div>
    <div class="details-container scrollable">
      <div class="card details" *ngIf="selectedRecord">
        <header>{{ selectedRecord.type }}</header>
        <div class="content">
          <div class="details-row" *ngFor="let row of selectedRecord.rows">
            <span class="label">{{ row.label }}</span>
            <span class="value">{{ row.value }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
